import { DOCUMENT } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	DestroyRef,
	inject,
	OnInit,
	Renderer2,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TextZoom } from '@capacitor/text-zoom';

import { ClientService } from '~app-client/core/services';

@Component({
	selector: 'fontsize-reactor',
	template: ``,
	styles: [':host { display: none; } '],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [],
})
export class FontSizeReactorComponent implements OnInit {
	private readonly destroyRef = inject(DestroyRef);
	private readonly clientService = inject(ClientService);
	private readonly renderer = inject(Renderer2);
	private readonly document = inject(DOCUMENT);

	ngOnInit(): void {
		this.changePreferredFontSize();

		this.clientService.appFocused$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((focused) => {
				if (focused) {
					this.changePreferredFontSize();
				}
			});
	}

	private async changePreferredFontSize(): Promise<void> {
		try {
			const preferred = await TextZoom.getPreferred();
			this.setPreferredFontSize(Math.max(1, Math.min(1.353, preferred?.value || 1)));
		} catch (error) {}
	}

	private setPreferredFontSize(preferred: number): void {
		try {
			TextZoom.set({ value: 1 });
			this.renderer.setStyle(
				this.document.documentElement,
				'fontSize',
				`${16 * preferred}px`
			);
		} catch (error) {}
	}
}
